import React from 'react';
import OverviewComponent from './instagram/OverviewComponent';
import ContentStudioComponent from './instagram/ContentStudioComponent';
import CampaignsComponent from './instagram/CampaignsComponent';
import AnalyticsComponent from './instagram/AnalyticsComponent';
import SettingsComponent from './instagram/SettingsComponent';

interface InstagramAgentSectionProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const InstagramAgentSection: React.FC<InstagramAgentSectionProps> = ({
  activeTab,
  setActiveTab
}) => {
  const renderTab = () => {
    switch (activeTab) {
      case 'content-studio':
        return <ContentStudioComponent />;
      case 'campaigns':
        return <CampaignsComponent />;
      case 'analytics':
        return <AnalyticsComponent />;
      case 'settings':
        return <SettingsComponent />;
      case 'overview':
      default:
        return <OverviewComponent setActiveTab={setActiveTab} />;
    }
  };

  return (
    <div className="space-y-8">
      {renderTab()}
    </div>
  );
};

export default InstagramAgentSection;
